import { AssetType } from '../../../asset-details/types';
import { TradeControllerVariants } from '../../utils';

export const getConvertedValueExplanation = (
  assetType: AssetType,
  tradeType: TradeControllerVariants,
  translations: {
    inclSpread: string;
    inclFees: string;
    afterSpread: string;
    afterFees: string;
    afterFeesAtCurrentPrice?: string;
    afterSpreadAtCurrentPrice?: string;
  },
) => {
  if (tradeType === 'buy' || tradeType === 'savings' || tradeType === 'swap') {
    if (assetType === AssetType.CRYPTO || assetType === AssetType.METAL) {
      return translations.inclFees;
    }

    return translations.inclSpread;
  }

  if (tradeType === 'order') {
    if (assetType === AssetType.CRYPTO || assetType === AssetType.METAL) {
      return translations.afterFeesAtCurrentPrice ?? translations.afterFees;
    }

    return translations.afterSpreadAtCurrentPrice ?? translations.afterSpread;
  }

  if (
    tradeType === 'sell' ||
    tradeType === 'stake' ||
    tradeType === 'unstake'
  ) {
    if (assetType === AssetType.CRYPTO || assetType === AssetType.METAL) {
      return translations.afterFees;
    }

    return translations.afterSpread;
  }
};
